import { getText } from "../i18n";

export const getMenuData = () => {
  const m = getText("pt-AO", "menu");

  return [
    {
      id: "painel-de-controle",
      label: m.dashboard,
      icon: "ri-dashboard-fill",
      href: "/dashboard",
    },
    {
      id: "main-gestao-estoque",
      label: "Área de Facturação",
      isTitle: true,
    },
    {
      id: "gestao-estoque",
      label: m.armazem,
      icon: "ri-stack-line",
      children: [
        {
          id: "produtos",
          label: "Produtos",
          href: "/armazem/produtos/",
        },
        {
          id: "entrada-estoque",
          label: "Armazem",
          href: "/armazem/estoque/entrada/",
        }
      ],
    },
    {
      id: "faturas",
      label: m.faturacao,
      icon: "ri-printer-cloud-line",
      children: [
        {
          id: "clientes",
          label: m.clientes,
          href: "/faturacao/clientes/",
        },
        {
          id: "fatura-recibo",
          label: "POS / Emitir Documento",
          href: "/pos/painel-caixas/",
        },
        {
          id: "faturas",
          label: m.ft_emitidas,
          href: "/faturacao/documentos/emitidos/",
        }
      ],
    },
    {
      id: "main-gestao-relatorios",
      label: "Estatísticas e Relatórios",
      isTitle: true,
    },
    {
      id: "relatorios",
      label: m.relatorios,
      icon: "ri-file-chart-line",
      children: [
        {
          id: "relatorio-vendas",
          label: "Relatório Geral",
          href: "/relatorios/vendas/",
        },
        {
          id: "relatorio-financeiro",
          label: "RelatÃ³rio Financeiro",
          href: "/relatorios/financeiro/",
        },
        {
          id: "conta-corrente",
          label: "Conta Corrente",
          href: "/relatorios/conta-corrente/",
        },
        {
          id: "vendas-usuario",
          label: "Fecho Diário",
          href: "/relatorios/usuario/",
        },
        {
          id: "ficheiro-saft",
          label: "SAFT (AO)",
          href: "/relatorios/ficheiro-saft/",
        },
      ],
    }
  ];
  
};
